import { combineReducers } from "redux";
import { pos } from "./pos";

export const reducers = combineReducers({
  pos,
});
